import React from 'react';
import {Box, Grid, TextField, Typography, Button, Autocomplete} from "@mui/material";
import swal from "sweetalert";
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import {getAllWellnessTopic, modifyWellnessChoice} from '../../../utilityFunctions/WellnessUtil';
import Colors from "../../../components/ui/Colors";
import NumberFormat from "react-number-format";
import { loaderAnimation } from '../../../Api';
import { useHistory } from "react-router-dom";

const choiceRequest = {};

const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

export default function ChangeWellnessChoice(props) {

    const {loginUser} = props;

    let history = useHistory();

    const [loading, setLoading] = React.useState(false);

    const [wellnessTopics, setWellnessTopics] = React.useState(null);
    const [wellnessTopic, setWellnessTopic] = React.useState(null);
    const [wellnessQuestion, setWellnessQuestion] = React.useState("");
    const [wellnessChoice, setWellnessChoice] = React.useState(null);

    React.useEffect(() => {
        const loadInitialValues = async () => {
            await initialValues();
        }
        loadInitialValues();
    }, []);

    const initialValues = async () => {
        
        setLoading(true);
        const response = await getAllWellnessTopic(loginUser.jwtToken);
        setLoading(false);

        if(!response){
            swal({
                title: "Error",
                text: "Failed to get wellness topics",
                icon: "error",
                button: "OK",
            });
            return;
        }

        setWellnessTopics(response);
    }

    const topicChange = (e, value) => {
        if(!value){
            return;
        }

        setWellnessTopic(value);
        
    };

    const questionChange = (e, value) => {
        if(!value){
            return;
        }

        setWellnessQuestion(value);
        
    };

    const choiceChange = (e, value) => {
        if(!value){
            return;
        }

        setWellnessChoice(value);
        setWellnessChoiceEditable(value.question);
        setWellnessChoiceScore(value.score);

        choiceRequest.choiceId = value.id;
        choiceRequest.score = value.score;
    }

    const [wellnessChoiceEditable, setWellnessChoiceEditable] = React.useState("");

    const changeChoiceText = (e) => {
        setWellnessChoiceEditable(e.target.value);
        choiceRequest.question = e.target.value;
    }

    const [wellnessChoiceScore, setWellnessChoiceScore] = React.useState("");

    const wellnessScoreChange = (values) => {
        choiceRequest.score = values.floatValue;
        setWellnessChoiceScore(values.floatValue);
    }

    const submitChoiceChange = async () => {
        setLoading(true);
        const response = await modifyWellnessChoice(choiceRequest, loginUser.jwtToken);
        setLoading(false);

        if(!response){
            swal({
                title: "Error",
                text: "Failed to modify wellness choice",
                icon: "error",
                button: "OK",
            });
            return;
        }

        swal({
            title: "Success",
            text: "Wellness choice modified",
            icon: "success",
            button: "OK",
        });

        history.push("/handle_profile");
    }



    return (
        <Box sx={{display: "flex", justifyContent: "center", width: "100%", height: "100%"}}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "95%",
                    height: "90%",
                    textAlign: "center",
                    marginTop: {xs: "1.3rem", sm: 0},
                }}
            >
                {loading ? loaderAnimation :
                    <Grid container direction="row" spacing={2}>
                    {wellnessTopics &&
                    <>
                        <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center"}}>
                            <Autocomplete
                                sx={{width: {xs: "90%", sm: "80%", md: "60%"}}}
                                options={wellnessTopics}
                                getOptionLabel={(option) => option.name}
                                clearOnEscape
                                autoComplete = {true}
                                noOptionsText = {"topic not found"}
                                fullWidth
                                onChange={topicChange}
                                renderInput={(params) => (
                                    <TextField  {...params} label="Topic" variant="standard" />
                                )}
                            />
                        </Grid>
                        {wellnessTopic && wellnessTopic.wellnessAttributes &&
                            <>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center"}}>
                                    <Autocomplete
                                        sx={{width: {xs: "90%", sm: "80%", md: "60%"}}}
                                        options={wellnessTopic.wellnessAttributes}
                                        getOptionLabel={(option) => option.name}
                                        clearOnEscape
                                        autoComplete = {true}
                                        noOptionsText = {"Question not found"}
                                        fullWidth
                                        onChange={questionChange}
                                        renderInput={(params) => (
                                            <TextField  {...params} label="Questions" variant="standard" />
                                        )}
                                    />
                                </Grid>
                                {wellnessQuestion && wellnessQuestion.wellnessChoices &&
                                    <>
                                        <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center"}}>
                                            <Autocomplete
                                                sx={{width: {xs: "90%", sm: "80%", md: "60%"}}}
                                                options={wellnessQuestion.wellnessChoices}
                                                getOptionLabel={(option) => option.question}
                                                clearOnEscape
                                                autoComplete = {true}
                                                noOptionsText = {"Question not found"}
                                                fullWidth
                                                onChange={choiceChange}
                                                renderInput={(params) => (
                                                    <TextField  {...params} label="Questions" variant="standard" />
                                                )}
                                            />
                                        </Grid>
                                        {wellnessChoice && wellnessChoiceEditable &&
                                        <>
                                            <Grid item xs={12} sm={12} md={12} sx={{marginTop: "1rem"}}>
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    multiline
                                                    rows={3}
                                                    label={<Typography variant="body2">Choice</Typography>}
                                                    value={wellnessChoiceEditable}
                                                    onChange={(e)=> changeChoiceText(e)}
                                                    autoComplete="off"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center"}}>
                                                <NumberFormat
                                                    variant="standard"
                                                    style={{width: "40%", height: "50%"}}
                                                    customInput={TextField}
                                                    // prefix={'$ '}
                                                    // suffix={' years'}
                                                    type="text"
                                                    label={<Typography variant="body2">Score</Typography>}
                                                    thousandSeparator={'.'}
                                                    decimalSeparator={','}
                                                    autoComplete="off"
                                                    value={wellnessChoiceScore}
                                                    onValueChange={(values) => {
                                                        wellnessScoreChange(values);
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12}>
                                                <Button onClick={submitChoiceChange} variant="contained" sx={{backgroundColor: Colors.primary, marginTop: "2rem",}}>
                                                    Submit
                                                </Button>
                                            </Grid>
                                        </>
                                        }
                                    </>
                                }
                            </>
                        }
                    </>
                    }
                    </Grid>
                }
            </Box>
        </Box>
    )
}
